/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ModalWithButtons from './ModalWithButtons';

const DeleteModal = (props) => {
  const primaryButtonPhrase = props.primaryButtonPhrase || { id: 'delete.deleteConfirm.button.label' };
  return (
    <ModalWithButtons
      isVisible={props.isVisible}
      options={{
        onDismiss: props.onCancelAction,
        isAutoDismissDisabled: props.isAutoDismissDisabled,
      }}
      buttons={[
        {
          type: 'primary',
          action: 'destructive',
          text: <FormattedMessage {...primaryButtonPhrase} />,
          onClick: props.onConfirmAction,
        },
        {
          type: 'secondary',
          action: 'default',
          text: <FormattedMessage id="delete.deleteCancel.button.label" />,
          onClick: props.onCancelAction,
        },
      ]}
    />
  );
}
DeleteModal.propTypes = {
  isVisible: PropTypes.bool,
  onConfirmAction: PropTypes.func,
  onCancelAction: PropTypes.func,
  primaryButtonPhrase: PropTypes.any,
  isAutoDismissDisabled: PropTypes.bool,
};

export default DeleteModal;
